import { useMemo } from "react"

import { useCurrentOverlay } from "shared/context/overlay/OverlayIDContext"
import { Action } from "shared/types/Action"

import { useSharedProjectScopedActionHandlers } from "features/project-management/model/useSharedProjectScopedActionHandlers"
import { ProjectActionsOverlayModel } from "widgets/project/project-actions-overlay/ProjectActionsOverlay"

import { SharedProjectActionsOverlayConnectorProps } from "../SharedProjectActionsOverlayConnector"

export function useSharedProjectActionsOverlayModel({
  payload: {
    projectID,
    projectShareID,
    additionalActions: payloadAdditionalActions
  }
}: SharedProjectActionsOverlayConnectorProps): ProjectActionsOverlayModel {
  const { closeOverlay } = useCurrentOverlay()

  const callbacks = useSharedProjectScopedActionHandlers({
    projectID,
    projectShareID,
    onAction: closeOverlay
  })

  const additionalActions = useMemo<Action[] | undefined>(() => {
    return payloadAdditionalActions?.map(action => ({
      ...action,
      onClick: ev => {
        action.onClick?.(ev)
        closeOverlay()
      }
    }))
  }, [payloadAdditionalActions, closeOverlay])

  return {
    ...callbacks,
    additionalActions,
    onCancel: closeOverlay
  }
}
